import { connect } from "@formily/react";
import { Switch as AntSwitch } from "@formily/antd-v5";

export const Switch = connect((props) => {
  const enhancedProps = {
    ...props,
  };

  return <AntSwitch {...enhancedProps} />;
});
